module.exports = __webpack_public_path__ + "img/medical_unit_h.ef815ca6.png";